module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/classic_desktop-cde95b77374f931c41f9dbe07ae09bd8.webp";